<template>
  <div id="applicant-edit-tab-internal-history">
    <ActionPage is-history type="APPLICANT" :resource-id="$route.params.id" />
  </div>
</template>

<script>
import ActionPage from "../../action/Page";

export default {
  components: {
    ActionPage
  }
};
</script>
